import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import { makeGetLabel } from '../selectors/labels';

import { createLabel, updateLabel, removeLabel } from '../actions/labels';

import { COLORS } from '../constants';

import FieldDefault from './field-default';
import ColorSelector from './color-selector';
import Tooltip from './tooltip';

import IconClose from '../icons/icon-close';
import IconRemove from '../icons/icon-remove';

class LabelEditor extends PureComponent { 
    state = {
        name: (this.props.label && this.props.label.name) || '',
        color: (this.props.label && this.props.label.color) || Object.keys(COLORS)[0]
    }

    handleNameChange = name => {
        this.setState({ name });
    }

    handleColorChange = color => {
        this.setState({ color });
    }

    handleSave = () => {
        if (this.editing) {
            updateLabel(this.props.labelId, {
                name: this.state.name,
                color: this.state.color
            });
        } else {
            createLabel({
                name: this.state.name,
                color: this.state.color
            }).then(({ id }) => {
                this.props.onCreate && this.props.onCreate(id);
            });
        }

        this.props.onSuccess && this.props.onSuccess();
    }

    handleRemove = () => {
        removeLabel(this.props.labelId);

        this.props.onSuccess && this.props.onSuccess();
    }

    get editing() {
        return Boolean(this.props.labelId);
    }

    get populated() {
        return this.state.name && this.state.name !== '';
    }

    render() {
        return (
            <React.Fragment>
                <div className="popout-head">
                    {this.editing ? 'EDIT' : 'CREATE A'} TAG

                    <button className="btn btn-icon btn-small popout-close" onClick={this.props.onClose}>
                        <IconClose />
                    </button>
                </div>

                <div className="popout-body">
                    <div className="label-body">
                        <FieldDefault
                            small={true}
                            placeholder="Type a name…"
                            value={this.state.name}
                            autoFocus={true}
                            onChange={this.handleNameChange}
                        />

                        <ColorSelector label="Select a color" selected={this.state.color} onChange={this.handleColorChange} />
                    </div>
                </div>

                <div className="popout-foot">
                    <div className="popout-actions">
                        {
                            this.editing ? (
                                <Tooltip tooltip="Delete Tag">
                                    <button className="btn btn-transparent btn-icon" onClick={this.handleRemove}><IconRemove /></button>
                                </Tooltip>
                            ) : null
                        }

                        <button className="btn btn-secondary" onClick={this.props.onCancel}>Cancel</button>

                        <button className="btn btn-success" onClick={this.handleSave} disabled={!this.populated}>{this.editing ? 'Update' : 'Save'}</button>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

const makeMapStateToProps = () => {
    const getLabel = makeGetLabel();

    return ({ labels }, ownProps) => {
        return {
            label: ownProps.labelId && getLabel(labels.items, ownProps.labelId)
        }
    }
};

export default connect(makeMapStateToProps)(LabelEditor);
